/**
 * Tiny event-tracking helper used by marketing pages to record page views
 * and outbound Stripe click-throughs. Fire-and-forget — never blocks UI.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api/track`;

function send(event, path) {
  try {
    const body = JSON.stringify({
      event,
      path: path || window.location.pathname,
      referrer: document.referrer || undefined,
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(API, new Blob([body], { type: "application/json" }));
    } else {
      fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (_e) {
    /* never let analytics block the page */
  }
}

export const trackPageView = (path) => send("page_view", path);
export const trackStripeClick = (path) => send("stripe_click", path);
